import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import PWAPrompt from 'react-ios-pwa-prompt';
import routes from 'src/routes';
import { Switch, useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { renderRoutes } from 'react-router-config';
import Topbar from './Topbar';
import { SaveLocalInvoiceAddress, setIpAddress, setSessionToken, setUserSession, setUserSessionFromLocale } from 'src/utils/Common';
import axios2 from 'axios';
import { CircularProgress, Grid, Typography, LinearProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    maxHeight: '100vh',
    // paddingTop: 20,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0
    }
  }
}));

function Auth() {
  const classes = useStyles();

  const [Loading, setLoading] = React.useState(true);
  const [Error, setError] = React.useState(null);
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  navigator.geolocation.getCurrentPosition(success, error, options);
  function success(pos) {
    // var crd = pos.coords;
  }

  function error(err) {
    console.log('Geolocation error:' + err.message);
  }
  const SaveLocal = async (UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId) => {
    SaveLocalInvoiceAddress(UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId);
  };

  useEffect(() => {
    if (authState === null) {
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect(fromUri);
    }
    if (authState !== null && authState.isAuthenticated) {
      oktaAuth.getUser().then(info => {
        if (info === undefined) {
          const fromUri = history.createHref(history.location);
          oktaAuth.signInWithRedirect(fromUri);
        }
        const UserNames = info?.preferred_username.split("@");
        const dataUser = [{
          UserName: UserNames[0],
          TerminalId: 1,
          VersionNr: process.env.REACT_APP_VERSION,
          TerminalIp: 1,
          LanguageId: 1
        }];
        const configUser = {
          headers: {
            'Content-Type': 'application/json'
            , 'IpAddress': 1
            , 'max-age': 86400
            , 'X-Frame-Options': 'DENY'
            , 'X-XSS-Protection': '1; mode=block'
            , 'accessToken': authState.accessToken.accessToken
            , 'Authorization': 'Bearer ' + authState.accessToken.accessToken
          }
        };

        // Session bilgilerine, sayım dönemi için harici değişken tanımlandı.
        let CountingPeriodAddress = process.env.REACT_APP_API_URL + "/GetCountingPeriodInformation";
        axios2.get(CountingPeriodAddress, configUser)
          .then((response) => {
            const data = response.data[0].SAYIM_DONEMI_AKTIF;
            localStorage.setItem("isCountingPeriod", data);
            sessionStorage.setItem("isCountingPeriod", data);
          }).catch((error) => {
            // Olası bir hata durumunda akış bozulmaması için 0 default atanmıştır.
            localStorage.setItem("isCountingPeriod", "0");
            sessionStorage.setItem("isCountingPeriod", "0");
          })


        let Address = process.env.REACT_APP_API_URL + "/GetUser";
        axios2.post(Address, dataUser, configUser)
          .then((response) => {
            setSessionToken(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '');
            setIpAddress(1);
            setUserSession(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '', response.data[0]);
            setLoading(false);
            SaveLocal(response.data[0].UserId, authState.accessToken.accessToken,
              response.data[0].ServiceShopCode, response.data[0].ServiceShopId,
              response.data[0].TechnicianId);
            SavePhoto(authState.accessToken.accessToken, response.data[0].UserId);
            setLoading(false);
            history.push('/profile/1/timeline');
          }).catch((error) => {
            setError("Kullanıcı Adı ve Parolanızı kontrol ediniz!...");
            setLoading(false);
            history.push('/Unauthorized');
          });
      });
    }
    if (authState !== null && !authState.isAuthenticated) {
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect(fromUri);
    }
  }, []);



  const SavePhoto = async (AuthToken, UserId) => {
    const configMenu = {
      headers: {
        'Content-Type': 'application/json'
        , 'IpAddress': ""
        , 'max-age': 86400
        , 'X-Frame-Options': 'DENY'
        , 'X-XSS-Protection': '1; mode=block'
        , 'Authorization': 'Bearer ' + AuthToken
        , 'Auth-UserId': UserId
        , 'SessionToken': AuthToken
        , 'Access-Control-Allow-Origin': '*'
      }
    };
    let Address = process.env.REACT_APP_API_URL + "/GetPhoto";
    axios2.post(Address, "", configMenu)
      .then((response) => {
        const Photo = response.data.length === 0 ? [] : response.data;
        localStorage.removeItem('UserPhoto');
        localStorage.setItem('UserPhoto', Photo[0].Photo);
      }).catch((error) => {
        localStorage.removeItem('UserPhoto');
        localStorage.setItem('UserPhoto', "");
        setLoading(false);
      });
  };




  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          {Loading &&
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
              style={{ minHeight: '100vh' }}
            >
              <Typography component="h2" gutterBottom variant="overline">
                Yönlendİrİlİyorsunuz
              </Typography>
              <CircularProgress disableShrink />
            </Grid>

          }
          <PWAPrompt
            promptOnVisit={1}
            timesToShow={3}
            copyTitle={'Ana Ekrana Ekle'}
            copyBody={
              'Mobil cihazınızın tarayıcısı üzerinden erişebileceğiniz Artemis uygulaması kolayca indirilebilir ve cihazınızda yer kaplamaz.'
            }
            copyShareButtonLabel={
              "1) Alt tarafta bulunan 'Paylaş' ikonuna dokunun"
            }
            copyAddHomeButtonLabel={
              "2) Açılan menüde bulunan 'Ana Ekrana Ekle'ye tıklayın"
            }
            copyClosePrompt={'Kapat'}
            permanentlyHideOnDismiss={false}
          />
          <Suspense fallback={<LinearProgress />}>
            <Switch>{renderRoutes(routes)}</Switch>
          </Suspense>
        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
